$('.clone-effect').each(function () {
    $(this).clone().appendTo($(this).parent());
});
